import { Building07, Home01, Settings01, ShieldZap, Users01 } from "@untitledui/icons";
import { useFeatureFlag } from "@/hooks/use-feature-flag";
import { useWorkspaceAdmin } from "@/hooks/use-workspace-admin";
import type { NavItem } from "./sidebar-layout";

const OVERVIEW_PATH = "/workspace/$workspaceId/overview";

export function useWorkspaceNavigationSections(): NavItem[] {
  const { workspace } = useWorkspaceAdmin();
  const hasSafety = workspace?.merchants.some((m) => m.features.includes("assurance")) ?? false;
  const canAddMerchants = useFeatureFlag("F-self-serve-add-merchant");

  const navigationSections: NavItem[] = [
    { enabled: true, id: "workspace-overview", label: "Overview", icon: Home01, path: OVERVIEW_PATH },
    {
      enabled: hasSafety,
      id: "workspace-safety",
      label: "Safety",
      icon: ShieldZap,
      description: "See how safe your workspace is and configure how to manage them",
      subItems: [
        {
          id: "workspace-safety",
          label: "Safety Overview",
          icon: ShieldZap,
          path: "/workspace/$workspaceId/safety",
        },
        {
          id: "workspace-safety-config",
          label: "Default safety settings",
          icon: Settings01,
          path: "/workspace/$workspaceId/safety/default-settings",
        },
      ],
    },
    {
      enabled: true,
      id: "workspace-settings",
      label: "Settings",
      icon: Settings01,
      description: canAddMerchants ? "Manage your merchants and team access" : "Manage who can access your merchants",
      subItems: [
        ...(canAddMerchants
          ? [
              {
                id: "workspace-merchants",
                label: "All merchants",
                icon: Building07,
                path: "/workspace/$workspaceId/settings/merchants",
              },
            ]
          : []),
        {
          id: "workspace-team",
          label: "Team",
          icon: Users01,
          path: "/workspace/$workspaceId/settings/team",
        },
      ],
    },
  ];

  return navigationSections;
}
